export const PROJECT_CATEGORIES = [
  {
    id: "element6",
    labelKey: "Acrylic Flooring",
    matchers: ["acrylic", "element6", "acrylic-flooring", "acrylic flooring"],
  },
  {
    id: "element1",
    labelKey: "Artificial Grass for Sports Surfaces",
    matchers: [
      "sports",
      "element1",
      "artificial grass for sports",
      "artificial-grass-sports",
      "sports surfaces",
    ],
  },
  {
    id: "element2",
    labelKey: "Artificial Grass for Landscape",
    matchers: [
      "landscape",
      "element2",
      "artificial grass for landscape",
      "artificial-grass-landscape",
    ],
  },
  {
    id: "element3",
    labelKey: "GYM Flooring",
    matchers: ["gym", "element3", "gym flooring", "gym-flooring"],
  },
  {
    id: "element4",
    labelKey: "Padel Tennis Flooring",
    matchers: ["padel", "element4", "padel tennis", "padel-tennis"],
  },
  {
    id: "element5",
    labelKey: "Tartan Flooring",
    matchers: ["tartan", "element5", "tartan flooring", "tartan-flooring"],
  },
];

export const DEFAULT_PROJECT_CATEGORY_ID = "element6";

export const PROJECT_CATEGORY_ORDER = PROJECT_CATEGORIES.map((category) => category.id);
